var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProfile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    viewBox: "0 0 284 284",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.7,60.4c-44.7,0-81,36.3-81,81s36.3,81,81,81,81-36.3,81-81-36.3-81-81-81ZM102.9,196.6c.3-.4.6-.8.9-1.3,7.3-14.5,21.9-23,37.2-23.3h1.8c6.2.1,12.5,1.6,18.4,4.6,8,4,14.7,10.7,18.7,18.7.2.4.5.8.8,1.2-11,7.7-24.4,12.3-38.8,12.4-14.7,0-28-4.6-39-12.3ZM121.2,136.9c0-11.3,9.2-20.5,20.5-20.5s20.5,9.2,20.5,20.5-8.7,19.9-19.5,20.4h-1.7c-11-.4-19.8-9.4-19.8-20.4ZM191.8,186.6c-5.5-9.8-14-17.9-24-23.1-.7-.3-1.4-.7-2.1-1,6.8-6.4,11.1-15.5,11.1-25.6,0-19.4-15.8-35.1-35.1-35.1s-35.1,15.8-35.1,35.1,4.3,19.3,11.2,25.7c-10.7,4.9-20,13.1-26.1,24.1-10.9-12-17.5-27.9-17.5-45.3,0-37.3,30.2-67.5,67.5-67.5s67.5,30.2,67.5,67.5-6.6,33.2-17.4,45.2Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/profile.da8c0d17.svg";
export { ForwardRef as ReactComponent };